import { render } from "./servicer-income.vue?vue&type=template&id=2e68533e&scoped=true"
const script = {}

import "./servicer-income.vue?vue&type=style&index=0&id=2e68533e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e68533e"]])

export default __exports__